export default function emptyInfoComponent () {
  'ngInject'
  return {
    restrict: 'E',
    scope: {},
    bindToController: {
      no: '@'
    },
    controller: () => {},
    controllerAs: 'ctrl',
    template: require('./empty-info.component.html').default
  }
}
